// extracted by mini-css-extract-plugin
module.exports = {"header":"EmployeeForm_header__qGrGL","account_warning":"EmployeeForm_account_warning__HSSLa","section_header":"EmployeeForm_section_header__dNnp-"};